import Request from '../Request';

/**
 * @class
 * Classe "abstrata" para implementação de busca de recursos.
 * @extends Request
 */
export default class Resource extends Request { }
